import { render, staticRenderFns } from "./PartnerReceipt.vue?vue&type=template&id=161af498&scoped=true"
import script from "./PartnerReceipt.vue?vue&type=script&lang=js"
export * from "./PartnerReceipt.vue?vue&type=script&lang=js"
import style0 from "./PartnerReceipt.vue?vue&type=style&index=0&id=161af498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161af498",
  null
  
)

export default component.exports